/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceValueResponse
 */
export interface PriceValueResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceValueResponse
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof PriceValueResponse
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof PriceValueResponse
     */
    formatted: string;
}

/**
 * Check if a given object implements the PriceValueResponse interface.
 */
export function instanceOfPriceValueResponse(value: object): value is PriceValueResponse {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('formatted' in value) || value['formatted'] === undefined) return false;
    return true;
}

export function PriceValueResponseFromJSON(json: any): PriceValueResponse {
    return PriceValueResponseFromJSONTyped(json, false);
}

export function PriceValueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceValueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': json['currency'],
        'formatted': json['formatted'],
    };
}

export function PriceValueResponseToJSON(value?: PriceValueResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
        'currency': value['currency'],
        'formatted': value['formatted'],
    };
}

